var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToolbarDesktop'),_c('NavigationDesktop'),_c('NavigationMobile'),_c('WorldDetails'),_c('Map'),_c('Charts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }